module.exports = __webpack_public_path__ + "img/activity_1_video_splash.f552f8bb.jpg";